import { useState, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../reduxToolkit/hooks";
import { menuList } from "../../../../data/layout/SidebarMenuList";
import { MenuItem } from "../../../../types/Layout";

import SubMenu from "./SubMenu";

const MenuList = () => {

  const { pinedMenu } = useAppSelector((state) => state.layout);
  const [activeMenu, setActiveMenu] = useState<MenuItem[]>([]);
  const { t } = useTranslation();
  const role = useAppSelector((state) => state.role.role);  // your role
  const shouldHideMenu = (mainMenu: MenuItem) => mainMenu?.Items?.map((data) => data.title).every((titles) => pinedMenu.includes(titles));
   // Filter menu sections based on role
   const filteredMenuList = menuList?.filter((mainMenu) => {
    if (!mainMenu.roles || mainMenu.roles.length === 0) return true; // no restriction
    return mainMenu.roles.includes(role || '');                          // check role
  });
  return (
    <>
      {filteredMenuList &&
        filteredMenuList.map((mainMenu, index) => (
          <Fragment key={index}>
            <li className={`sidebar-main-title ${shouldHideMenu(mainMenu) ? "d-none" : ""}`}>
              <div>
                <h6>{t(`${mainMenu.title}`)}</h6>
              </div>
            </li>
            <SubMenu menu={mainMenu.Items} activeMenu={activeMenu} setActiveMenu={setActiveMenu} level={0} />
          </Fragment>
        ))}
    </>
  );
};

export default MenuList;
